import * as React from 'react';

import {
  GranteeListItemTitle,
  GranteeInfo,
  StyledGranteeIcon,
  GranteeListItemContainer,
} from 'components/permissions/CommonStyledComponents';
import type { CollectionGrantee } from 'collections/types';
import TitleCell from 'collections/components/EntitiesList/cells/TitleCell';

type Props = {
  grantee: CollectionGrantee;
};

const CollectionGranteesListItem = ({
  grantee: { grantee, granteeName, capability, collection_name, collection_total, collection_id },
}: Props) => {
  const capabilityRole = {
    view: 'Viewer',
    manage: 'Manager',
    own: 'Owner',
  };

  return (
    <GranteeListItemContainer $currentState={null}>
      <GranteeInfo title={granteeName}>
        <StyledGranteeIcon type={grantee?.includes('user') ? 'user' : 'team'} />
        <GranteeListItemTitle>{granteeName}</GranteeListItemTitle>
      </GranteeInfo>
      <GranteeInfo>
        <TitleCell name={collection_name} type="collection" id={collection_id} />
        {collection_total > 1 && <span>&nbsp;+ {collection_total - 1} more</span>}
      </GranteeInfo>
      <GranteeInfo>{capabilityRole[capability]}</GranteeInfo>
    </GranteeListItemContainer>
  );
};

export default CollectionGranteesListItem;
